import moment from "moment";

export const formatCartProceedPayload = (products_in_cart, client_code, mandate_id = null) => {
  const payload = products_in_cart.map((res) => {
    const masterScheme = res?.cart_product?.master_scheme;
    
    return {
      master_scheme_id: masterScheme?.id,
      amc_code: masterScheme?.amc_code,
      scheme_code: masterScheme?.scheme_code,
      isin: masterScheme?.isin,
      folioNumber: res?.folioNumber ? res?.folioNumber : (res?.cart_product?.folio || ""),
      amount: res?.amount,
      reinvest: res?.reinvest ? res?.reinvest : (res?.cart_product?.reinvest || "Z"),
      is_additional_purchase: res?.is_additional_purchase 
        ? res?.is_additional_purchase 
        : (res?.cart_product?.trxn_mode === "ADDITIONAL" ? "true" : "false"),
      investment_mode: res?.investment_mode,
      minimum_amount: res?.minimum_amount || masterScheme?.new_purchase_min_amount || "0",
      date_installment: res?.date_installment
        ? moment(res?.date_installment, ["YYYY-MM-DD", "DD/MM/YYYY"]).format("DD/MM/YYYY")
        : (res?.cart_product?.sip_start_date || ""),
      frequency_type: res?.frequency_type,
      frequency_allowed: res?.frequency_allowed || "1",
      sip_remarks: res?.sip_remarks ? res?.sip_remarks : (res?.cart_product?.sip_remarks || ""),
      installment_no: res?.installment_no ? res?.installment_no : "",
      first_order_today: res?.first_order_today ? res?.first_order_today : (res?.cart_product?.first_order_today || "N"),
      step_up_required: res?.step_up_required ? res?.step_up_required : (res?.cart_product?.step_up_required || "N"),
      step_up_start_date: res?.step_up_start_date ? res?.step_up_start_date : (res?.cart_product?.step_up_start_date || ""),
      step_up_end_date: res?.step_up_end_date ? res?.step_up_end_date : (res?.cart_product?.step_up_end_date || ""),
      step_up_frequency: res?.step_up_frequency ? res?.step_up_frequency : (res?.cart_product?.step_up_frequency || ""),
      step_up_amount: res?.step_up_amount ? res?.step_up_amount : (res?.cart_product?.step_up_amount || ""),
      until_cancel: res?.investment_mode === "S" ? res?.until_cancel : 0,
    };
  });

  return {
    products_in_cart: payload,
    client_code: client_code,
    ...(mandate_id && { mandate_id }),
  };
};
